import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  NotificationDto,
  NotificationsPageDto,
} from '../../interfaces/notifications/notification.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationsGatewayService {
  private readonly urlPrefix = `${environment.api.url}/api/notifications`;

  constructor(private httpClient: HttpClient) {}

  getList(page: number = 0, size: number = 10): Observable<NotificationsPageDto> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.httpClient.get<NotificationsPageDto>(this.urlPrefix, { params });
  }

  getById(id: number): Observable<NotificationDto> {
    return this.httpClient.get<NotificationDto>(`${this.urlPrefix}/${id}`);
  }

  markAsDelivered(id: number): Observable<NotificationDto> {
    return this.httpClient.patch<NotificationDto>(`${this.urlPrefix}/${id}/mark-delivered`, {});
  }
}
